export enum SUB_GAME_GROUP {
    LIVE_BLACKJACK = "Live Blackjack",
    LIVE_ROULETTE = "Live Roulette",
    LIVE_BACCART = "Live Baccarat",
    LIVE_POKER = "Live Poker",
    LIVE_SLOT = "Live Slot",
    LIVE_GAME_SHOWS = "Live Game Shows"
}